import React, { useEffect, useState } from 'react';
import IntroductionPageStyle from './style';
import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import ViewAndEditQuoteIntro from 'src/components/viewAndEditQuoteIntro';
import { contentfulSelector } from 'src/redux/selectors/contentfulSelector';
import useQueryApi from 'src/hooks/useApiQuery';
import { getDetailExpert } from 'src/api/apiGetDetailExpert';
import WhyBook from './whyBook';
import NextSteps from './nextSteps';
import Reviews from './reviews';
import MainImageComponent from 'src/components/mainImageComponent';
import useIsMobile from 'src/hooks/useIsMobile';
import BookYourEvent from './bookYourEvent';
import { paramsQuoteDetailSelector } from 'src/redux/selectors/paramsQuoteDetailSelector';
import { ENV } from 'src/const/evn';
import { formatCurrency } from 'src/const/contain';
import CartWrap from 'src/components/cartWrap';
import { toggleEditQuoteSelector } from 'src/redux/selectors/toggleEditQuoteSelector';
import icons from 'src/assets/icon';
import CommentComponent from 'src/components/comment';
import { isEmptyHtml } from 'src/utils/valid';
import { getTextFromRichText } from 'src/utils/helper';
import useQuoteTemplate from 'src/hooks/useQuoteTemplate';

const IntroductionPage: React.FC = () => {
    const {
        intro = '',
        isEvent,
        clientComments,
        resConsultant,
        safariIntro,
        id: quoteId,
        price: priceTotal,
        priceAgentComment,
    } = useSelector(quoteDetailSelector);

    const { totalDeposit } = priceTotal;

    const {
        agentIntroStandard,
        salesAgentIntroTournament,
        salesAgentIntroSafariTournament,
        salesAgentIntroSafariRow,
    } = useSelector(contentfulSelector);

    const { introParagraph = [], promotionalMessage = [] } = clientComments;

    const { name: nameConsultant } = resConsultant;

    const isMobile: boolean = useIsMobile();
    const isEdit = useSelector(toggleEditQuoteSelector);

    const params = useSelector(paramsQuoteDetailSelector);
    const { isSafariLayout: getIsSafariTemplate, isRowTemplate } =
        useQuoteTemplate();

    const [isAddComment, setIsAddComment] = useState(false);

    const { data: detailExpert }: any = useQueryApi(
        ['nameResConsultant', nameConsultant],
        () => getDetailExpert(nameConsultant),
        {
            enabled: !!nameConsultant,
        },
    );

    const extractDetailExpert = (data: any[]) => {
        return data
            ?.map((item: any) =>
                item.content.map((content: any) => content.value).join('<br>'),
            )
            .join('<br>');
    };

    const introQuote = !isEmptyHtml(intro)
        ? intro
        : isEvent
        ? getTextFromRichText(salesAgentIntroTournament)
        : getTextFromRichText(agentIntroStandard);

    const safariIntroQuote = !isEmptyHtml(safariIntro)
        ? safariIntro
        : getTextFromRichText(
              isRowTemplate
                  ? salesAgentIntroSafariRow
                  : salesAgentIntroSafariTournament,
          );

    useEffect(() => {
        setIsAddComment(false);
    }, [isEdit]);

    const renderBoxIntro = () => (
        <div className="box-intro">
            <ViewAndEditQuoteIntro initialValue={introQuote} />
            {introParagraph.length > 0 && (
                <div
                    className="m-bottom max-w"
                    dangerouslySetInnerHTML={{
                        __html: introParagraph
                            .join('<br /><br />')
                            .replace(/\n/g, '<br />'),
                    }}
                ></div>
            )}
            {promotionalMessage.length > 0 && (
                <div className="m-bottom max-w">
                    <b
                        dangerouslySetInnerHTML={{
                            __html: promotionalMessage
                                .join('')
                                .replace(/\n/g, '<br />'),
                        }}
                    ></b>
                </div>
            )}
        </div>
    );

    const renderBoxAbout = () => (
        <div className="box-about">
            <div className="intro-title">
                About <span className="color-success">{nameConsultant} </span> -
                Your Golf Travel Expert
            </div>
            <div
                className="detail"
                dangerouslySetInnerHTML={{
                    __html: extractDetailExpert(
                        detailExpert?.fields?.documentation?.content || [],
                    ),
                }}
            ></div>
        </div>
    );

    const renderSafariIntro = () => (
        <div className="box-intro">
            <ViewAndEditQuoteIntro
                initialValue={safariIntroQuote}
                field="safariIntro"
            />
        </div>
    );

    const renderSafariReadyToBook = () => (
        <div className="ready-book">
            <div className="title-ready">Ready to book?</div>
            <a
                href={`${ENV.URL_PAYMENT}/quotes/QV${quoteId}`}
                className="btn-pay"
                target="_blank"
                rel="noreferrer"
            >
                Click here to pay your £{formatCurrency(totalDeposit)} deposit
                and secure your holiday
            </a>
        </div>
    );

    const renderCart = () => (
        <div className={isEdit ? 'box-cart edit' : 'box-cart'}>
            <div className="title">Pricing Breakdown</div>
            <div className="sub-title">Quote Reference: {quoteId}</div>
            <CartWrap isMiniCart={false} />
            {isEdit && renderComment()}
        </div>
    );

    const renderComment = () => (
        <div className="iconAddComment" onClick={() => setIsAddComment(true)}>
            <img alt="" src={icons.addComment} />
        </div>
    );

    const renderContent = () => {
        if (getIsSafariTemplate) {
            return (
                <>
                    {renderSafariIntro()}
                    {renderCart()}
                    <CommentComponent
                        isEdit={isAddComment}
                        initialValue={
                            params?.priceAgentComment || priceAgentComment
                        }
                        onChangeToggleInput={() =>
                            setIsAddComment(!isAddComment)
                        }
                    />
                    {renderSafariReadyToBook()}
                </>
            );
        }
        return (
            <>
                {renderBoxIntro()}
                <NextSteps />
                <WhyBook />
                <Reviews />
                {renderBoxAbout()}
                <BookYourEvent />
            </>
        );
    };

    return (
        <IntroductionPageStyle>
            {!isMobile && <MainImageComponent />}
            {renderContent()}
        </IntroductionPageStyle>
    );
};

export default IntroductionPage;
